import { Guid } from "../util/Guid";

/** Wizard configuration class. Used to configure a wizard and synchronise it's state. */
export class WizardConfig {

	private _targetElement: Element;
	private _steps: Array<WizardStep>;
	private _activeStepElement: HTMLInputElement | null;

	/**
	 * Initialises a new instance of the WizardConfig class.
	 * @param targetElement The element containing the wizard steps.
	 * @param steps Array of WizardStep.
	 * @param activeStepElement The currently active step element.
	 */
	constructor(targetElement: Element, steps: Array<WizardStep>, activeStepElement: HTMLInputElement | null) {
		this._targetElement = targetElement;
		this._steps = steps;
		this._activeStepElement = activeStepElement;
	}

	/**
	 * Array of wizard steps.
	 * @see WizardStep
	 */ 
	public get steps(): Array<WizardStep> {

		return this._steps;
	}

	/** The element containing the wizard steps. */
	public get targetElement(): Element {

		return this._targetElement;
	}

	/** The currently active step element. */
	public get activeStepElement(): HTMLInputElement | null {

		return this._activeStepElement;
	}
}

/** Wizard step configuration class. Used to configure a wizard step and synchronise it's state. */
export class WizardStep {

	title: string;
	content: Element;
	index: number;
	guid: string;
    visible: boolean;
	navigatable: boolean;
	completed: boolean;

	/**
	 * Initialises a new instance of the WizardStep class.
	 * @param stepElement The element containing step content.
	 * @param title Step title, displayed as the header for the wizard step.
	 * @param index The step index.
	 */
	constructor(stepElement: Element, title: string, index: number) {

		this.title = title;
		this.content = stepElement;
		this.index = index;
		this.guid = Guid.newGuid();
		this.visible = true;
		this.navigatable = stepElement.getAttribute("data-navigatable") === "true";
		this.completed = stepElement.getAttribute("data-completed") === "true";
	}

	/** The step key, used to identify the step. */
	get key() {

		const stepKey = this.content.getAttribute("data-step");
		return stepKey || `Step${this.index}`;
	}
}